import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiSetting } from '../../core/models/setting';
import { environment } from '../../../environments/environment';
import { RequestWrap } from '../../core/models/request-wrap';

const preferencesUrl = '/settings'

@Injectable()
export class PreferencesService {
  constructor(private http: HttpClient) {}

  getTenantSpecificPreferences(): Observable<ApiSetting[]> {
    return this.http.get<RequestWrap<ApiSetting[]>>(
      `${environment.baseApiUrl}${preferencesUrl}`
    ).pipe(
      map(res => res && res.results))
  }
}
